import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getLocations, editLocation, createLocation} from '../../actions/locations';
import SearchableList from '../partials/SearchableList';
import SelectableListItem from '../partials/SelectableListItem';
import {destructServerErrors, allErrors} from '../../helpers/error';
import LocationModal from './LocationModal';
import LocationDeleteModal from './LocationDeleteModal';
import {formData, clearFormInputs} from '../../helpers/form';
import __ from '../../helpers/translation';
import {scheduleInspection} from "../../actions/inspections";
import localforage from "localforage";

const propTypes = {
    onSelected: PropTypes.func.isRequired,
    getLocations: PropTypes.func.isRequired,
    createLocation: PropTypes.func.isRequired,
    editLocation: PropTypes.func.isRequired,
    selectedCompany: PropTypes.object.isRequired,
    currentItem: PropTypes.object
};


class LocationSelect extends Component {
    constructor(props) {
        super(props);
        this.searchList = React.createRef();
        this.locations = [];
        this.currentItem = props.currentItem ? props.currentItem : null;
        this.onSelected = props.onSelected;
        this.template = this.template.bind(this);
        this.company = this.props.selectedCompany;

        this.deleteLocation = this.deleteLocation.bind(this);
        this.editLocation = this.editLocation.bind(this);
        this.loadLocations = this.loadLocations.bind(this);

        this.state = {
            modal: {
                'errors': null,
                'loading': false
            },
            'deleteItem': null,
            'editItem': null,
            'preview': false,
            'schedule': false
        }
    }

    addLocation() {
        this.setState({
            'editItem': null,
        }, () => {
            window.$('#modalAddLocation').modal('show');
        });
    }

    editLocation(item) {
        this.setState({
            'editItem': item,
            'preview': false
        }, () => {
            window.$('#listActions' + item.id).modal('hide');
            window.$('#modalAddLocation').modal('show');
        });
    }

    deleteLocation(item) {
        this.setState({
            'deleteItem': item
        }, () => {
            window.$('#listActions' + item.id).modal('hide');
            window.$('#deleteLocation').modal('show');
        });
    }

    previewLocation(item) {
        this.setState({
            'editItem': item,
            'preview': true
        }, () => {
            window.$('#listActions' + item.id).modal('hide');
            window.$('#modalAddLocation').modal('show');
        });
    }

    scheduleLocation(item) {
        this.setState({
            'editItem': item,
            'preview': false,
            'schedule': true,
        }, () => {
            window.$('#listActions' + item.id).modal('hide');
            scheduleInspection({ locationId: item.id });
        });
    }

    fullTitle(item) {
        return item.name + (item.departament ? ', ' + item.departament : '');
    }

    fullAddress(item) {
        let address = '';
        address += item.address ? item.address : '';
        address += item.zipcode ? (address.length > 0 ? ', ' : '') + item.zipcode : '';
        address += item.city ? (address.length > 0 ? (item.zipcode ? ' ' : ', ') : '') + item.city : '';
        return address;
    }

    template(item) {
        let fullAddress = this.fullAddress(item);
        let fullTitle = this.fullTitle(item);
        return <SelectableListItem
            key={item.id.toString()}
            id={item.id.toString()}
            name={'locations'}
            title={fullTitle}
            subtitle={fullAddress}
            selected={this.currentItem && this.currentItem.id == item.id}
            onSelect={(e) => this.onSelected(item)}
            actions={
                <React.Fragment>
                    <a className="d-flex flex-row text-dark font-size-18 cur-p"
                       onClick={(e) => {
                           this.previewLocation(item)
                       }}>
                        <div className="icon-container">
                            <i className="far fa-info"></i>
                        </div>
                        <p>{__('app.general.preview')}</p>
                    </a>
                    <a className="d-flex flex-row text-dark font-size-18 cur-p"
                       onClick={(e) => {
                           this.scheduleLocation(item)
                       }}>
                        <div className="icon-container">
                            <i className="far fa-clock"></i>
                        </div>
                        <p>
                            {__('app.general.schedule')}
                        </p>
                    </a>
                    {item.can_edit ? (
                        <a className="d-flex flex-row text-dark font-size-18 cur-p"
                           onClick={(e) => {
                               this.editLocation(item)
                           }}>
                            <div className="icon-container">
                                <i className="far fa-pencil"></i>
                            </div>
                            <p>{__('app.general.edit')}</p>
                        </a>) : ('')}
                    {item.is_owner ? (
                        <a className="d-flex flex-row text-dark font-size-18 cur-p"
                           onClick={(e) => {
                               this.deleteLocation(item)
                           }}>
                            <div className="icon-container">
                                <i className="far fa-trash"></i>
                            </div>
                            <p>{__('app.general.delete')}</p>
                        </a>) : ('')}
                </React.Fragment>
            }
        />;
    }

    handleModal(e) {
        e.preventDefault();

        this.setState({
            'modal': {
                'loading': true
            }
        });

        let form = e.target;
        let data = formData(form);

        if (this.state.editItem) {
            return this.updateLocation(form, data);
        }

        this.props.createLocation(this.company, data)
            .then(data => {
                this.searchList.current.setState(prevState => ({
                    items: [
                        ...prevState.items,
                        data.location
                    ]
                }));
                this.setState({
                    'modal': {
                        'loading': false,
                        'errors': null
                    }
                });
                clearFormInputs(form);
            })
            .catch(error => {
                this.setState({
                    'modal': {
                        'errors': allErrors(destructServerErrors(error))
                    }
                });
                return Promise.reject(error)
            });
    }

    updateLocation(form, data) {
        this.props.editLocation(this.company, this.state.editItem, data)
            .then(data => {
                this.searchList.current.setState(prevState => {

                    let updateIndex = prevState.items
                        .findIndex(location => location.id === data.location.id);

                    let newState = prevState;
                    if (newState.items[updateIndex]) {
                        newState.items[updateIndex] = data.location;
                    }

                    return newState
                });
                this.setState({
                    'modal': {
                        'loading': false,
                        'errors': null
                    },
                    editItem: null
                });
                clearFormInputs(form);
            })
            .catch(error => {
                this.setState({
                    'modal': {
                        'errors': allErrors(destructServerErrors(error))
                    }
                });
                return Promise.reject(error)
            });
    }

    loadLocations() {
        this.searchList.current.setState({
            loading: true
        });

        if (window.navigator.onLine) {
            return this.props.getLocations(this.company)
                .then(data => {
                    this.locations = data.locations;
                    this.searchList.current.setState({
                        items: data.locations,
                        loading: false
                    })
                })
                .catch(error => {
                    return Promise.reject(error)
                })
        } else {
            try {
                localforage.setDriver(localforage.INDEXEDDB);
                localforage.getItem('bs_locations_' + this.company.id)
                    .then(locations => {
                        if (locations) {
                            this.locations = locations;
                            this.searchList.current.setState({
                                items: locations,
                                loading: false
                            })
                        }
                    });

                return Promise.resolve({...this.locations});

            } catch (e) {
                return Promise.reject(e);
            }
        }
    }

    componentDidMount() {
        this.loadLocations();
    }

    render() {
      return (
        <>
          <div className="d-flex justify-content-between">
            <h1 className="fw-600 d-inline-block">{__('app.inspections.title_location')}</h1>
            <i className="far fa-plus d-inline-block md-plus" onClick={() => this.addLocation()}></i>
          </div>

          <SearchableList
            ref={this.searchList}
            template={this.template}
            items={this.locations}
            searchField={'name'}
            loading={true}
          />
          
          <LocationModal
            previewMode={this.state.preview} 
            modal={this.state.modal}
            location={this.state.editItem} 
            callback={(e) => this.handleModal(e)}
            companyId={this.company.id}
          />

          <LocationDeleteModal
            location={this.state.deleteItem}
            onDeleted={() => {
              this.setState({
                deleteItem: null,
                editItem: null
              });
              this.loadLocations();
            }}
          />

        </>
      )
    }
}

LocationSelect.propTypes = propTypes;

const mapDispatchToProps = {
    getLocations,
    createLocation,
    editLocation
};

export default connect(null, mapDispatchToProps)(LocationSelect);